import {all} from 'redux-saga/effects';
import user from './user';
import authSagas from './Auth';
import forgotPassword_sagas from './forgotPassword';
import patients_sagas from "./patients";
import kpi_sagas from "./kpi";
import otp_saga from "./otp";
import home from "./home";
import realtime from "./realtime";
import deviceConfig from './deviceConfig';
import datacenter from './Data_Center_Saga';
export default function* rootSaga() {
    yield all([
        user(),
        authSagas(),
        forgotPassword_sagas(),
        patients_sagas(),
        kpi_sagas(),
        otp_saga(),
        home(),
        realtime(),    
        deviceConfig(),
        datacenter(),
    ]);
}
